var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00007 22H15.0001M5.00007 9C5.00007 5.13401 8.13408 2 12.0001 2C15.8661 2 19.0001 5.13401 19.0001 9V11.5778C19.0001 13.1572 19.4676 14.7013 20.3437 16.0154L20.8333 16.7498C20.9173 16.8758 20.8585 17.0472 20.7148 17.0951C15.058 18.9807 8.94216 18.9807 3.28532 17.0951C3.14166 17.0472 3.08286 16.8758 3.16685 16.7498L3.65647 16.0154C4.53257 14.7013 5.00007 13.1572 5.00007 11.5778V9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlt);
export default __webpack_public_path__ + "static/media/notification-alt.6190799e581c3ea4e6078fcd59c05d97.svg";
export { ForwardRef as ReactComponent };